import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    CountryIcon: {

    }
}));

const CountryIcon = ({
    countryCode,
    className,
    onClick
}) => {
    const classes = useStyles();
    return (
        <svg
            className={clsx(classes.CountryIcon, className)}
            onClick={onClick}
        >
            <use href={`/images/countries.svg#${countryCode}`} />
        </svg>
    );
};

CountryIcon.defaultProps = {
};

CountryIcon.propTypes = {
    countryCode: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func
};

export default CountryIcon;
